import {SupplierInput} from "@/endpoints/rutsolve/gql/generated/types"

export class SupplierSelector {
    static readonly supplierInput: string = "SUPPLIER_SELECTOR_SUPPLIER_INPUT"
    static readonly selectedSupplierID: string = "SUPPLIER_SELECTOR_SELECTED_SUPPLIER_ID"

    private static defaultSupplierInput: SupplierInput = {
        order: "UPDATED_AT_DESCENDING",
        plot: {
            items: 10,
            page: 1
        },
    }

    public static readSupplierInput(): SupplierInput {
        const supplierInput = sessionStorage.getItem(this.supplierInput)
        if (supplierInput) {
            return JSON.parse(supplierInput) as SupplierInput
        }
        return this.defaultSupplierInput
    }

    public static readSelectedSupplierID(): string {
        return sessionStorage.getItem(this.selectedSupplierID)
    }

    public static writeSupplierInput(input: SupplierInput) {
        sessionStorage.setItem(this.supplierInput, JSON.stringify(input))
    }

    public static writeSelectedSupplierID(input: string) {
        sessionStorage.setItem(this.selectedSupplierID, input)
    }

    public static deleteSupplierInput() {
        sessionStorage.removeItem(this.supplierInput)
    }

    public static deleteSelectedSupplierID() {
        sessionStorage.removeItem(this.selectedSupplierID)
    }
}
